import React from "react";
import {
  ButtonBase,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import Icon from "../../../../components/Icon/Icon";

/** Direct access menu item */
export const SidebarItem = ({
  item,
  open,
  isActive,
  contentVisible,
  onClickItem,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <>
      {open ? (
        <>
          {contentVisible && (
            <ListItemButton
              component={Link}
              to={`/${item.segment}`}
              selected={isActive(item.segment)}
              sx={{
                height: 38,
                justifyContent: "initial",
                mx: 1,
                borderRadius: 2,
                py: 0,
              }}
              onClick={() => onClickItem?.()}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: 2,
                }}
              >
                <Icon
                  name={item.iconName}
                  color={
                    isActive(item.segment)
                      ? theme.palette.primary.main
                      : theme.palette.secondary.main
                  }
                />
              </ListItemIcon>
              <ListItemText
                primary={item.title}
                primaryTypographyProps={{
                  color: isActive(item.segment) ? "primary" : "secondary",
                  fontWeight: 600,
                  fontSize: 12.5,
                }}
              />
            </ListItemButton>
          )}
        </>
      ) : (
        <ButtonBase
          onClick={() => navigate(`/${item.segment}`)}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            p: 0.75,
            width: "85%",
            mx: "auto",
            ml: 0.75,
            borderRadius: 2,
            cursor: "pointer",
            transition: "background 0.3s",
            bgcolor: isActive(item.segment) && theme.palette.paleBlue2.main,
            height: 48,
            "&:hover": {
              bgcolor: theme.palette.paleBlue.main,
            },
          }}
          focusRipple
        >
          <Icon
            name={item.iconName}
            color={
              isActive(item.segment)
                ? theme.palette.primary.main
                : theme.palette.secondary.main
            }
          />
          <Typography
            variant="caption"
            fontSize={10}
            fontWeight={600}
            textAlign="center"
            color={isActive(item.segment) ? "primary" : "secondary"}
          >
            {item.title}
          </Typography>
        </ButtonBase>
      )}
    </>
  );
};
